import React from 'react';
import Services from './Services';
import ContactSection from './ContactSection';
import HeroSlider from './HeroSlider.jsx';
import ContactForm from './ContactForm.jsx';
import TeamSection from './TeamSection.jsx';
import AsystoPage from './AsystoPage.jsx';
import ADHDSection from './ADHDSection';

export default function Hero() {
  return (
    <>
      <HeroSlider />
      <AsystoPage />
      <TeamSection />
      <ADHDSection />
      <ContactForm />
      <ContactSection />
    </>
  );
}
